import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "matchtype", "ignore"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Children, cloneElement, useState, useEffect } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { jsx as _jsx } from "react/jsx-runtime";

function match(type, a, b) {
  if (type === "full") {
    return a === b;
  } else if (type === "partial") {
    return b.startsWith(a);
  }
}

export default function ActiveLink(_ref) {
  var children = _ref.children,
      _ref$matchtype = _ref.matchtype,
      matchtype = _ref$matchtype === void 0 ? "full" : _ref$matchtype,
      _ref$ignore = _ref.ignore,
      ignore = _ref$ignore === void 0 ? null : _ref$ignore,
      props = _objectWithoutProperties(_ref, _excluded);

  var router = useRouter();
  var child = Children.only(children);
  var childClassName = child.props.className || "";

  var _useState = useState(childClassName),
      className = _useState[0],
      setClassName = _useState[1];

  useEffect(function () {
    var className = childClassName;

    if (!match(matchtype, ignore, router.asPath) && (match(matchtype, props.href, router.asPath) || match(matchtype, props.as, router.asPath))) {
      className = "".concat(childClassName, " active").trim();
    }

    setClassName(className);
  }, [props.href, props.as, childClassName, router.asPath]);
  return /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/cloneElement(child, {
      className: className
    })
  }));
}